import { DashboardLoader } from "./dashboard-loader";
import { DashboardWidget } from "./dashboard-widget";
import { PluginStatusSet, type PageIdentifier, type PluginEntry } from "../types";
import { Show, type Component } from "solid-js";

type DashboardEntryProps = {
  entry: PluginEntry;
  onNavigate: (pageId: PageIdentifier) => void;
};

export const DashboardEntry: Component<DashboardEntryProps> = (props) => {
  const isLoaded = () => props.entry.status === PluginStatusSet.LOADED;
  const hasPage = () => props.entry.registration?.page != null;

  const widgetClasses = () => {
    const wClassArray = [];
    if (isLoaded()) {
      wClassArray.push("Dashboard__Widget--loaded");
    }
    if (isLoaded() && hasPage()) {
      wClassArray.push("Dashboard__Widget--clickable");
    }
    return wClassArray.join(" ");
  };

  return (
    <Show when={isLoaded() && props.entry.registration} fallback={<DashboardLoader />}>
      {(() => {
        const WidgetComponent = props.entry.registration!.widget;
        return (
          <DashboardWidget
            class={widgetClasses()}
            onClick={() => {
              props.onNavigate(props.entry.id);
            }}
            title={props.entry.name}
            widgetIcon={props.entry.registration!.pluginIcon}
          >
            <WidgetComponent pluginIcon={props.entry.registration!.pluginIcon} />
          </DashboardWidget>
        );
      })()}
    </Show>
  );
};
